import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, ElementRef, Input, OnChanges, QueryList, SimpleChanges, ViewChildren } from '@angular/core';

@Component({
  selector: 'app-custom-stepper',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './custom-stepper.component.html',
  styleUrl: './custom-stepper.component.scss'
})
export class CustomStepperComponent implements AfterViewInit, OnChanges {

  @Input() stepCount: number;
  @Input() selectedStep: number;

  @ViewChildren('stepRef') stepElements!: QueryList<ElementRef>;

  constructor() {

  }

  get steps(): number[] {
    return Array(this.stepCount).fill(0).map((_, i) => i + 1);
  }

  ngAfterViewInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedStep && !changes.selectedStep.firstChange) {
      this.scrollToSelectedStep();
    }
  }

  scrollToSelectedStep() {
    setTimeout(() => {
      const selected = this.stepElements.get(this.selectedStep);
      selected?.nativeElement.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    });
  }

  change(step) {
    // this.selectedStep = step;
    // this.scrollToSelectedStep()
  }
}
